import Link from "next/link";
import { MdOutlineEmail } from "react-icons/md";
import { PiTelegramLogoDuotone } from "react-icons/pi";

const TopBar = () => {
  return (
    <div className="h-10 bg-bg1">
      <div className="container h-full flex items-center justify-between">
        <div className="flex items-center gap-3 lg:gap-5 lg:justify-start justify-between w-full">
          <p className="shrink-0 text-text1 text-[8px] lg:text-xs m-0">
            Earn more anywhere by joining our dalal affiliate program now!
          </p>
        </div>

        <div className="hidden lg:flex items-center gap-5 text-lg">
          <Link
            title="mailto:support.bd@dalalaff.com"
            href="mailto:support.bd@dalalaff.com"
          >
            <MdOutlineEmail className="text-white cursor-pointer hover:text-[#da7927]" />
          </Link>

          {/* <MdOutlineEmail className="text-white" /> */}

          {/* <PiTelegramLogoDuotone className="text-white" /> */}

          <Link
            title="https://t.me/dalal_official"
            href="https://t.me/dalal_official"
            target="_blank"
          >
            <PiTelegramLogoDuotone className="text-white cursor-pointer hover:text-[#da7927]" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
